module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_02-95764022d61479294e22cc84f1e2b7ba.jpg";